import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  containter: {
    alignItems: 'flex-start',
    marginTop: '8px',
    [theme.breakpoints.down(960)]: {
      marginBottom: '8px',
      gap: '6px',
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
}));
